import { render, staticRenderFns } from "./AffiliatesSecondTierExportModal.vue?vue&type=template&id=6b6a3d3c&scoped=true"
import script from "./AffiliatesSecondTierExportModal.vue?vue&type=script&lang=js"
export * from "./AffiliatesSecondTierExportModal.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesSecondTierExportModal.vue?vue&type=style&index=0&id=6b6a3d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a3d3c",
  null
  
)

export default component.exports